import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { styles } from '../posShared.styles';
import { DINING_TABLE_STATUS_LABELS } from '../../../hospitality/domain/hospitalityTypes'
import type { DiningTable } from '../../../hospitality/domain/hospitalityTypes';
import { ModalShell } from '../../../shared/modals/ModalShell';
import { posSharedUi as posUi } from '../../../shared/ui/posSharedUi';

type DiningTablePickerModalProps = {
  visible: boolean;
  loading: boolean;
  options: DiningTable[];
  onSelect: (id: string | null) => void;
  onClose: () => void;
};

export function DiningTablePickerModal({
  visible,
  loading,
  options,
  onSelect,
  onClose,
}: DiningTablePickerModalProps) {
  return (
    <ModalShell
      visible={visible}
      onClose={onClose}
      title="Elegir mesa"
      subtitle="Si querés, asignala a una mesa."
      keyboardAvoiding={false}
      widthVariant="compact"
      footer={
        <TouchableOpacity
          style={[posUi.secondaryButton, { flex: 1 }]}
          onPress={onClose}
          accessibilityRole="button"
          accessibilityLabel="Cancelar"
        >
          <Text style={posUi.secondaryButtonText}>Cancelar</Text>
        </TouchableOpacity>
      }
    >
      {loading ? (
        <Text style={styles.diningTableHint}>Cargando mesas…</Text>
      ) : (
        <View style={styles.diningTableList}>
          <TouchableOpacity
            style={styles.diningTableRow}
            onPress={() => onSelect(null)}
            activeOpacity={0.7}
            accessibilityRole="button"
            accessibilityLabel="Continuar sin mesa"
          >
            <Text style={styles.diningTableRowText}>Sin mesa / mostrador</Text>
          </TouchableOpacity>
          {options.map((table) => {
            const isOccupied = table.status === 'occupied';
            return (
              <TouchableOpacity
                key={table.id}
                style={[
                  styles.diningTableRow,
                  isOccupied && styles.diningTableRowDisabled,
                ]}
                onPress={() => onSelect(table.id)}
                activeOpacity={isOccupied ? 1 : 0.7}
                disabled={isOccupied}
                accessibilityRole="button"
                accessibilityLabel={`Mesa ${table.name}`}
                accessibilityState={{ disabled: isOccupied }}
              >
                <Text style={styles.diningTableRowText}>
                  {table.name} · {table.capacity} comensales
                </Text>
                <Text
                  style={[
                    styles.diningTableRowMeta,
                    isOccupied && styles.diningTableRowMetaOccupied,
                  ]}
                >
                  {DINING_TABLE_STATUS_LABELS[table.status]}
                </Text>
              </TouchableOpacity>
            );
          })}
        </View>
      )}
    </ModalShell>
  );
}
